import React, { useState, useEffect } from "react";
import Button from "@mui/material/Button";
import axios from "axios";
import { useMutation } from "@tanstack/react-query";
import { useNavigate } from "react-router-dom";
import Cookies from 'js-cookie';
import PrivacyPolicyModal from "./privacyPolicy/PrivacyPolicyModal";
import SaasModal from "./privacyPolicy/SaasModel";
import EulaModal from "./privacyPolicy/eulaModal";

import styles from "./Login.module.scss";

function Login() {
  const [isCapture, setIsCapture] = useState(false);
  const [showPrivacyModal, setShowPrivacyModal] = useState(false);
  const [showSAASModal, setShowSAASModal] = useState(false);
  const [showEulaModal, setShoweulaModal] = useState(false);

  const [privacyContent, setPrivacyContent] = useState("");
  const [SAASContent, setSAASContent] = useState("");
  const [eulaContent, setEulaContent] = useState("");
  const isMobile = window.innerWidth <= 768;

  const navigate = useNavigate();

  const login = useMutation(
     
    () => {
      console.log("Login successful:");
      const capture = isCapture ? "capture" : "default";
      return axios.get(`/auth/get_dentally_request_auth_link?capture=${capture}`);
    },
    {
      onSuccess: (data) => {
        console.log("Login successful:", data);
        window.location.replace(data.data);
      },
    }
  );

  const handlePrivacyClick = async () => {
    try {
      const response = await axios.get(`document_agreement/3`);
      setPrivacyContent(response.data.document);
      setShowPrivacyModal(true);
    } catch (error) {
      setPrivacyContent("Failed to load Privacy Policy.");
      setShowPrivacyModal(true);
    }
  };

  const handleSAASClick = async () => {
    try {
      const response = await axios.get("document_agreement/2");
      setSAASContent(response.data.document);
      setShowSAASModal(true);
    } catch (error) {
      setSAASContent("Failed to load SAAS.");
      setShowSAASModal(true);
    }
  };

  const handleEulaClick = async () => {
    try {
      const response = await axios.get("document_agreement/1");
      setEulaContent(response.data.document);
      setShoweulaModal(true);
    } catch (error) {
      setEulaContent("Failed to load EULA.");
      setShoweulaModal(true);
    }
  };

  return (
    <div className={styles.pageContainer}>
      <div className={styles.loginContainer}>
        {/* Left Panel */}
        <div className={styles.leftPanel}>
          <img src="/logo.png" alt="Medicube Logo" className={styles.logo} />
          <div className={styles.subtitle}>
            <p className={styles.orangeText}>Make your consent clauses</p>
            <p className={styles.captionText}>
              & match them to your frequently used treatment codes
            </p>
          </div>
          <img src="/image_dent.png" alt="Dental illustration" className={styles.image} />
        </div>

        {/* Right Panel */}
        <div className={styles.rightPanel}>
         <div className={styles.aboutTopRight}>
          <button className={styles.aboutButton} onClick={() => alert("About info here")}>
            About
          </button>
        </div>
          <h2 className={styles.title}>Welcome!</h2>
          <Button
            className={styles.dentallyButton}
            
           onClick={() => {
              Cookies.remove("isCapture"); 
              login.mutate();
            }}
            disabled={login.isLoading}
          >
            <div className={styles.loginContent}>
              <p>Login via <img src="/dentally-Photoroom.png" alt="Dentally Logo" /></p>
            </div>
            
          </Button>

        {isMobile && (
  <Button
   sx={{color: '#0e2453',
      fontSize: '1rem',
    border: '1px solid #ccc',
      height: '60px',
   borderRadius: '9999px',
   boxShadow: '0 2px 6px rgba(0, 0, 0, 0.2)', }}
    className={styles.mobileCaptureButton}
    onClick={() => {
      Cookies.set("isCapture", "true", { expires: 1 });
      login.mutate();
    }}
    disabled={login.isLoading}
  >
    Image Capture
  </Button>
)}

        </div>
      </div>

      {/* Footer */}
      <footer className={styles.footer}>
        <div className={styles.footerContent}>
          <img src="/logo.png" alt="Company Logo" className={styles.logo} />
          <div className={styles.divider}></div>
          <div>
            <p>&copy; 2024 Medicube. All rights reserved.</p>
            <p>
              <a onClick={handlePrivacyClick} className={styles.link}>Privacy Policy</a> |
              <a onClick={handleSAASClick} className={styles.link}>SAAS</a> |
              <a onClick={handleEulaClick} className={styles.link}>EULA</a>
            </p>
          </div>
        </div>
      </footer>

      <PrivacyPolicyModal
        open={showPrivacyModal}
        onClose={() => setShowPrivacyModal(false)}
        content={privacyContent}
      />
      <SaasModal
        open={showSAASModal}
        onClose={() => setShowSAASModal(false)}
        content={SAASContent}
      />
      <EulaModal
        open={showEulaModal}
        onClose={() => setShoweulaModal(false)}
        content={eulaContent}
      />
    </div>
  );
}

export default Login;
